export default __webpack_public_path__ + "static/media/al-badar logo 02.857e96c1.png";